<template>
    <div>
        <div>
        <p>
            Selecteer een periode
        </p>
        <a-select v-model="year" style="width: 120px;" @change="onChange">
            <a-select-option v-for="year in years" :key="year" :value="year">{{year}}</a-select-option>
        </a-select>
        <a-button type="primary" @click="downloadCsv">Download CSV</a-button>

        </div>
    </div>
</template>

<script>

export default {
  computed: {
    user: {
      get: function () {
        return this.$store.state.user
      },
    },
  },
  data() {
    return {
      revenueLoading: false,
      year: null,
      years: [],
    }
  },
  mounted() {
    // years since 2021
    for (let i = 2021; i <= new Date().getFullYear(); i++) {
      this.years.push(i)
    }
    // reverse the array
    this.years.reverse()
  },
  methods: {
    downloadCsv() {
      this.$axios.post('/bookkeeping/getYukiCsvExport', {
        year: this.year,
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        // download the csv
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        // create datestring with seconds for filename
        const date = new Date()
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const day = date.getDate()
        const hours = date.getHours()
        const minutes = date.getMinutes()
        const seconds = date.getSeconds()
        const dateString = `${year}${month}${day}${hours}${minutes}${seconds}`

        link.setAttribute('download', `rps-csv-export-${year}-${dateString}.csv`)
        document.body.appendChild(link)
        link.click()
      })
    },
  },
}

</script>
